module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/results01-53187bab072e5b4dcf72587fbeea059b.png";